import React from "react";
import { PropagateLoader } from "react-spinners";

const Loader = ({color  = "#FFFFFF", size = 15}) => (
    <div className="flex pt-3 pb-6 w-full items-center justify-center">
        <PropagateLoader color={color} size={`${size}px`} />
    </div>
);

export default Loader